/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Import_Status_ReceivingInputs */



/**
* | output |
* | --- |
* | "Receiving project from Iconik..." |
*
* @param {Iconik_Import_Status_ReceivingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_import_status_receiving = /** @type {((inputs?: Iconik_Import_Status_ReceivingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Import_Status_ReceivingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Reception du projet depuis Iconik...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Erhalt eines Projekts von Iconik...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ricezione del progetto da Iconik...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Получение проекта от Iconik...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Recibiendo proyecto de Iconik...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在接收来自 Iconik 的项目……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Iconik からプロジェクトを受け取っています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Iconik से प्रोजेक्ट प्राप्त हुआ...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Recebendo projeto da Iconik...")
	return /** @type {LocalizedString} */ ("Receiving project from Iconik...")
});